import { gstStateCodes } from "../constants/data"

export const getStateName = (code: keyof typeof gstStateCodes) => {
  return gstStateCodes[code]
}
